import { useRouter } from "next/router";
import { useCallback, useEffect, useMemo } from "react";
import { useFlag } from "../../../hooks/useFlag";
import { resetAuth, updateAuth } from "../authSlice";
import { useDispatch } from "react-redux";
import { parseHash } from "../../auth0/functions/parseHash";
import useTranslateMessage from "../../../hooks/useTranslateMessage";

const useSuccessfulSocialLogin = () => {
  const t = useTranslateMessage();
  const dispatch = useDispatch();

  const { push, asPath } = useRouter();

  const [isSuccessful, setSuccessfulTrue, setSuccessfulFalse] = useFlag();
  const [isLoading, setLoadingTrue, setLoadingFalse] = useFlag();

  const DEFAULT_ERROR_MESSAGE = t({
    id: "useSuccessfulSocialLogin-DEFAULT_ERROR_MESSAGE",
  });

  const message = useMemo(
    () =>
      isLoading
        ? t({ id: "useSuccessfulSocialLogin-21,11" })
        : isSuccessful
        ? t({ id: "useSuccessfulSocialLogin-redirect" })
        : DEFAULT_ERROR_MESSAGE,
    [DEFAULT_ERROR_MESSAGE, isLoading, isSuccessful, t],
  );

  const handleRedirectToApp = useCallback(() => {
    push("/catalog");
  }, [push]);

  useEffect(() => {
    setLoadingTrue();

    const hash = asPath.split("#")[1];

    if (hash) {
      parseHash({ hash })
        .then((auth) => {
          dispatch(updateAuth(auth));

          setSuccessfulTrue();
        })
        .catch(() => {
          dispatch(resetAuth());

          setSuccessfulFalse();
        })
        .finally(() => {
          setLoadingFalse();
        });
    }
  }, [
    asPath,
    dispatch,
    setLoadingFalse,
    setLoadingTrue,
    setSuccessfulFalse,
    setSuccessfulTrue,
  ]);

  useEffect(() => {
    if (!isLoading && isSuccessful) {
      setTimeout(() => {
        handleRedirectToApp();
      }, 1000);
    }
  }, [handleRedirectToApp, isLoading, isSuccessful]);

  return {
    isLoading,
    isSuccessful,
    message,
    handleRedirectToApp,
  };
};

export { useSuccessfulSocialLogin };
